import { useAppQuery } from '@api/query/use-app-query';
import { FrontierService } from '@api';
import { inventoryResourceQueryDocument } from '@Inventory/services/gql';
import { InventoryFilterInput, PaginationInput } from '@api/gql/graphql';
import { InventoryQueryKeys } from '@Inventory/services/queryKeys';

export function useInventoryResource(resourceId: string, filter?: InventoryFilterInput, pagination?: PaginationInput) {
  return useAppQuery(
    [InventoryQueryKeys.InventoryResource, JSON.stringify({ filter, pagination })],
    async () => {
      return FrontierService.request(inventoryResourceQueryDocument, {
        filter: { query: `resource="${resourceId}"` + (filter?.query ? ` AND (${filter.query})` : '') },
        pagination,
      });
    },
    {
      keepPreviousData: true,
    },
  );
}
